import React from 'react';
import SacWaitingRoom from 'presentation/pages/SacWaitingRoom';

const MakeSacLeaveFactory: React.FC = () => {
  return <SacWaitingRoom leave />;
};

export default MakeSacLeaveFactory;
